// extracted by mini-css-extract-plugin
module.exports = {"course-meta-info":"course-card-details_course-meta-info__uYhk6","row":"course-card-details_row__sWQ8g"};